const initResidencesLinks = () => {
	const rooms = document.querySelectorAll('.floor-plate__room');
	if (rooms.length > 0) {
		rooms.forEach((room) => {
			room.addEventListener('click', (evt) => {
				if (room.classList.contains('active')) {
					// console.log(`${window.location.href}${room.id}`);
					location.assign(`${window.location.href}${room.id}`);
				}
			});
		});
	}
};

export default initResidencesLinks;
